<template>
  <div>
    <v-menu
      v-if="locale.currentCountry"
      width="220"
      location="bottom right"
      scroll-strategy="close"
    >
      <template #activator="{ props: menuProps }">
        <v-btn
          v-bind="menuProps"
          class="px-0"
          min-width="56"
          max-width="56"
          height="48"
        >
          <v-img
            width="24"
            max-width="24"
            height="24"
            :src="COUNTRY_FLAG_IMAGE[locale.currentCountry]"
          />
        </v-btn>
      </template>

      <CountryLinksList
        class="py-2"
        show-selected
      />
    </v-menu>
  </div>
</template>

<script setup lang="ts">
import { COUNTRY_FLAG_IMAGE } from '~/core/i18n'
import CountryLinksList from './CountryLinksList.vue'

const locale = useAppLocale()
</script>
